import { createSlice } from '@reduxjs/toolkit';
import { loadingPauseReducer } from './reducers/loading-pause.reducer';
import { updatePauseReducer } from './reducers/update-pause.reducer';
import { pauseErrorReducer } from './reducers/pause-error.reducer';
import { createCustomerPauseReducer } from './reducers/create-pause.reducer';
import { initialPauseState } from './state';

export const pauseSlice = createSlice({
  name: 'Pause',
  initialState: initialPauseState,
  reducers: {
    loading: loadingPauseReducer,
    update: updatePauseReducer,
    error: pauseErrorReducer,
    create: createCustomerPauseReducer,
  },
});

export const pauseReducer = pauseSlice.reducer;
